var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.176758,
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9628 34.5005H44.3918V36.4366L45.8113 37.2707L47.4628 36.3019L49.6773 40.199L48.0261 41.1675V42.8334L49.6771 43.8019L47.4626 47.699L45.8113 46.7303L44.3918 47.5644V49.5005H39.9628V47.5644L38.5433 46.7303L36.8918 47.699L34.6773 43.8019L36.3284 42.8334V41.1677L34.6772 40.199L36.8917 36.3019L38.5433 37.2707L39.9628 36.4366V34.5005ZM42.1773 44.5005C43.558 44.5005 44.6773 43.3812 44.6773 42.0005C44.6773 40.6198 43.558 39.5005 42.1773 39.5005C40.7965 39.5005 39.6773 40.6198 39.6773 42.0005C39.6773 43.3812 40.7965 44.5005 42.1773 44.5005Z",
    fill: "#466AEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1772 31.0059C36.1053 31.0059 31.1829 35.9283 31.1829 42.0003C31.1829 43.5661 31.5096 45.0525 32.0972 46.3975L29.8584 47.3756C29.1385 45.728 28.7397 43.9091 28.7397 42.0003C28.7397 34.5789 34.7559 28.5627 42.1772 28.5627C44.8808 28.5627 47.3991 29.362 49.5068 30.7361V29.7843H51.9499V33.2763C51.9499 33.7682 51.6549 34.2121 51.2014 34.4026C50.7479 34.5931 50.2244 34.493 49.8732 34.1487C47.8888 32.2034 45.1741 31.0059 42.1772 31.0059ZM53.1716 42.0003C53.1716 40.4344 52.8449 38.948 52.2573 37.603L54.4961 36.6248C55.2159 38.2725 55.6147 40.0914 55.6147 42.0003C55.6147 49.4215 49.5986 55.4378 42.1772 55.4378C39.4737 55.4378 36.9555 54.6385 34.8477 53.2644V54.2161H32.4045V50.7241C32.4045 50.2323 32.6995 49.7884 33.153 49.5979C33.6065 49.4074 34.13 49.5075 34.4813 49.8518C36.4656 51.7971 39.1804 52.9945 42.1772 52.9945C48.2492 52.9945 53.1716 48.0723 53.1716 42.0003Z",
    fill: "#466AEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/Management.aa8687827f4e9953c661cfe2cefae505.svg";
export { ForwardRef as ReactComponent };